module.exports = __webpack_public_path__ + "static/media/solution14.3f5126ce.png";